module.exports = __webpack_public_path__ + "static/media/Trastes.0f0c7370.jpg";